import { render } from "./ProductsGrid.vue?vue&type=template&id=42041ba1&scoped=true"
import script from "./ProductsGrid.vue?vue&type=script&lang=js"
export * from "./ProductsGrid.vue?vue&type=script&lang=js"

import "./ProductsGrid.vue?vue&type=style&index=0&id=42041ba1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42041ba1"]])

export default __exports__